import { gql } from '@apollo/client';

export const OrganizationFragment = gql`
  fragment Organization on Organization {
    code
    name
    description
    dateCreation
    owners {
      firstName
      lastName
      email
    }
  }
`;